import React from 'react';
import classNames from 'classnames';
import { COLORS, COMMUNITIES_TO_NAMES, IDS_TO_COMMUNITIES } from '../constants';

const hrefBase = `${process.env.PUBLIC_URL}/organization/?search=`;

export default class Tooltip extends React.Component {
    render() {
        const { features } = this.props;

        // eslint-disable-next-line no-shadow
        const renderFeature = (features, i) => (
                <div className="organizations__popups">
                  <div className="mapboxgl-popup-tip"/>
                  <article
                      className={classNames(`organizations__popup markerpopup isPopup`)}
                      key={i}
                  >
                      {/* <a className="isPopup" href={`${hrefBase}${features.properties.id}`}> */}
                          <span className={ `category ${ COLORS[features.properties.category_id]} isPopup` }>
                              {COMMUNITIES_TO_NAMES[IDS_TO_COMMUNITIES[features.properties.category_id]]}
                          </span>
                          <div className="copy isPopup">
                              <h3 className="isPopup">
                                  <span className="isPopup">{features.properties.name}</span>
                              </h3>
                              <address className="isPopup">
                                  {features.properties.city}, {features.properties.state}
                              </address>
                              {/* <p className="text-cta isPopup">See the Impact</p> */}
                          </div>
                      {/* </a> */}
                  </article>
                </div>
            );

        return renderFeature(features);
    }
}
